import { SupportProvider } from '../../core/env-config';
import { IntercomService } from '../services/intercom.service';
import { ZendeskService } from '../services/zendesk.service';

export const SUPPORT_PROVIDER_MAP = {
  [SupportProvider.INTERCOM]: IntercomService,
  [SupportProvider.ZENDESK]: ZendeskService
};
